import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ScrollableAnchor from 'react-scrollable-anchor';
import { translate } from "react-i18next";

import i18n from "utils/i18n";

import './ContactForm.module.css';

import icon from 'Images/icon.png';

/*
ContactForm.propTypes = {
  data: PropTypes.shape({
    phone: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      brand: PropTypes.string.isRequired,
    })),
  }).isRequired,
}; */

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class ContactForm extends Component {

  state = {
    message: '',
    message_error: null,
    email: '',
    email_error: null,
    name: '',
    name_error: null,
    product: '',
    justsomefield: '',
    submitted: false,
    success: null,
    error: null,
    attemptedSubmit: false,
  };

  handleChange = (e) => {
    const newState = {
      [e.target.id]: e.target.value
    }

    this.validate(newState);
  };

  validate = (newState) => {

    newState['email_error'] = this.validateField('email', newState.email || this.state.email);
    newState['message_error'] = this.validateField('message', newState.message || this.state.message);
    newState['name_error'] = this.validateField('name', newState.name || this.state.name);

    this.setState(newState);
    return newState;
  };

  validateField = (fieldName, value) => {
    switch (fieldName) {
      case 'email':
        if (!value) {
          return "Email ist ein Pflichtfeld!";
        }
        const emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        return emailValid ? null : 'Die eingegebene Email Adresse ist nicht gültig!';
      case 'message':
        if (!value) {
          return "Nachricht ist ein Pflichtfeld!";
        }
        const messageValid = value.length >= 20;
        return messageValid ? null : 'Nachricht ist zu kurz, es müssen mindestens 20 Zeichen eingegeben werden!';
      case 'name':
        if (!value) {
          return "Name ist ein Pflichtfeld!";
        }
        const nameValid = value.length >= 3;
        return nameValid ? null : 'Sie müssen einen Namen angeben!';
      default:
        break;
    }
    return null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.validate({});
    setTimeout(() => {
      this.submitForm(e)
    }, 10);
  }

  submitForm = (e) => {
    const hasErrors = !(this.state.message_error === null
      && this.state.name_error === null
      && this.state.email_error === null);

    this.setState({
      attemptedSubmit: true
    });

    if (hasErrors) {
      e.preventDefault();
      return false;
    }
    fetch("https://mailproxy.projects.localhost.at/index.php", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "mailId": 'montadrill',
        "email": this.state.email,
        "name": this.state.name,
        "product": `${this.props.product.brand} ${this.props.product.additionalName} ${this.props.product.name}`,
        "message": this.state.message
      })
    })
      .then(() => {
        this.setState({
          message: '',
          submitted: true,
          success: true,
          error: null
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          submitted: true,
          success: false,
          error: error.message
        });
      });

    e.preventDefault();
  };

  render() {
    const node = this.props.product;

    const formErrors = [
      this.state.email_error,
      this.state.name_error,
      this.state.message_error
    ].filter((value) => {
      return value !== null
    });

    return (
        <section styleName="ContactForm">
            <form
              name="Kontaktformular Montadrill"
              onSubmit={this.handleSubmit}>

              <input type="hidden" name="form-name" value="Kontaktformular Montadrill" />
              <input type="hidden" id="justsomefield" name="justsomefield" value={this.state.justsomefield} onChange={this.handleChange} />
              <input type="text" placeholder="Name" name="Name" id="name" value={this.state.name} onChange={this.handleChange} />
              <input type="text" placeholder="Email" name="Email" id="email" value={this.state.email} onChange={this.handleChange} />
              <input type="hidden" name="Produkt" id="product" value={`${node.brand} ${node.additionalName} ${node.name}`} />

              <textarea
                placeholder="Ihre Nachricht"
                name="Nachricht"
                id="message"
                onChange={this.handleChange}
                value={this.state.message}
              />
              {
                this.state.attemptedSubmit && formErrors.length > 0 &&
                  <div styleName="errorContainer">
                    { formErrors.map((error) => (
                      <div>{ error }</div>
                    ))}
                  </div>
              }
              <button>Senden</button>
              {
                this.state.success &&
                  <div styleName="successMessage">
                    Ihre Nachricht wurde erfolgreich versandt.
                  </div>
              }
              {
                this.state.success === false && this.state.error &&
                <div styleName="errorMessage">
                  Fehler: {this.state.error}
                </div>
              }
            </form>
        </section>
    );
  }
}

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Products/ContactForm.js